import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
    TextField,
    Card,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    BottomNavigation,
    BottomNavigationAction
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import { createMuiTheme } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    getTasksRequest
} from '../../store/actions';
import SearchBar from 'material-ui-search-bar';
import { workOrderCargoActions, workOrderCargoThunks } from '../../store/slices/workOrderCargoSlice'
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import BusinessIcon from '@material-ui/icons/Business';
import WorkOrderCargoScreen from './WorkOrderCargoScreen';
import CargoReport from './CargoReport'

const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    warning: {
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.warning.main,
        fontWeight: theme.typography.fontWeightMedium,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.33%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    }
}));



const WorkOrderCargo = ({ getTasksRequest }) => {
    const classes = useStyles();
    const { t } = useTranslation('overview');
    const SessionUser = getUser();
    const dispatch = useDispatch();

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [AlertType, setAlertType] = React.useState();
    const [WorkOrderHaveCargoRecord, setWorkOrderHaveCargoRecord] = React.useState(false)
    const [WorkOrderSearched, setWorkOrderSearched] = React.useState(false)
    const [Loading, setLoading] = useState(false);
    const [ResponseDsc, setResponseDsc] = useState('');
    const [WorkOrderFound, setWorkOrderFound] = useState(false)
    const [menuSelectionValue, setMenuSelectionValue] = useState(0)

    const searched = useSelector((state) => state.workOrderCargo.searched)
    const workOrderCargo = useSelector((state) => state.workOrderCargo.workOrderCargo)
    const cargoCompanies = useSelector((state) => state.workOrderCargo.cargoCompanies)
    const selectedCargoCompany = useSelector((state) => state.workOrderCargo.selectedCargoCompany)
    const selectedCargoNo = useSelector((state) => state.workOrderCargo.selectedCargoNo)
    const selectedDispatchDate = useSelector((state) => state.workOrderCargo.selectedDispatchDate)

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    useEffect(() => {
        loadCargoCompanies()
    }, []);

    const loadCargoCompanies = () => {
        setLoading(true);
        dispatch(workOrderCargoThunks.GetCargoCompanies())
            .then((response) => {
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const requestSearch = (searchValue) => {
        setLoading(true);
        dispatch(workOrderCargoThunks.GetWorkOrderCargo(({ workOrderId: searchValue })))
            .then((response) => {
                if (response?.payload?.Code !== '400') {
                    setResponseDsc(response?.payload?.Message);
                    setAlertType('error');
                    setOpenSnackbar(true)
                    setWorkOrderSearched(false)
                    setWorkOrderFound(false)
                    dispatch(workOrderCargoActions.setSelectedCargoCompany(null))
                    dispatch(workOrderCargoActions.setselectedCargoNo(''))
                    dispatch(workOrderCargoActions.setSelectedDispatchDate(null))
                }
                else {
                    setWorkOrderHaveCargoRecord(response?.payload?.ResponseObject?.Id == 0 ? false : true)
                    setWorkOrderSearched(true)

                    if (response?.payload?.ResponseObject?.CargoCompanyId == null) {
                        dispatch(workOrderCargoActions.setSelectedCargoCompany(null))
                    }
                    else {
                        var cargoCompany = cargoCompanies.find(x => x.Id == response?.payload?.ResponseObject?.CargoCompanyId)
                        dispatch(workOrderCargoActions.setSelectedCargoCompany(cargoCompany))
                    }

                    dispatch(workOrderCargoActions.setselectedCargoNo(response?.payload?.ResponseObject?.CargoNo))
                    dispatch(workOrderCargoActions.setSelectedDispatchDate(response?.payload?.ResponseObject?.DispatchDate))

                    setWorkOrderFound(true)
                }

                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                setResponseDsc(error);
                setAlertType('error');
                setOpenSnackbar(true)
            });
    };

    const setWorkOrderCargo = () => {
        if (selectedCargoCompany == null || (selectedCargoNo == null || selectedCargoNo == '')) {
            setResponseDsc(t('lblWorkOrderCargoSaveError'));
            setAlertType('error');
            setOpenSnackbar(true)
        }

        let data = {
            workOrderId: workOrderCargo.ResponseObject.WorkOrderId,
            Id: workOrderCargo.ResponseObject.Id,
            cargoCompanyId: selectedCargoCompany.Id,
            cargoNo: selectedCargoNo,
            dispatchDate: selectedDispatchDate
        }

        dispatch(workOrderCargoThunks.SetWorkOrderCargo(data)).then(response => {
            if (response?.payload?.Code === '400') {
                setResponseDsc(t('lblWorkOrderCargoSaveSuccess'));
                setAlertType('success');
                setOpenSnackbar(true)
                requestSearch(searched)
            }
            else {
                setResponseDsc(response?.payload?.Message);
                setAlertType('error');
                setOpenSnackbar(true)
            }
        })
    }


    return (
        <Page>
            <Backdrop className={classes.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose} message={ResponseDsc} variant={AlertType}
                />
            </Snackbar>
            <Container maxWidth="xl">
                <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('lblWorkOrderCargoModule')}</Typography>
                </Breadcrumbs>
                <br />
                <Card>
                    <CardContent>
                        <BottomNavigation
                            className={classes.stickToBottom}
                            value={menuSelectionValue}
                            onChange={(event, newValue) => {
                                setMenuSelectionValue(newValue);
                            }}
                            showLabels
                        >
                            <BottomNavigationAction label={t('lblCargoScreen')} icon={<BusinessIcon />} />
                            <BottomNavigationAction label={t('lblCargoReport')} icon={<FolderSharedIcon />} />
                        </BottomNavigation>
                    </CardContent>
                    <CardContent>
                        {parseInt(menuSelectionValue) === 0 ? <WorkOrderCargoScreen /> : ''}
                        {parseInt(menuSelectionValue) === 1 ? <CargoReport /> : ''}
                    </CardContent>
                </Card>
            </Container>
        </Page >
    );
}
export default connect(state => ({
    tasks: state.tasks1,
}), {
    getTasksRequest,
})(WorkOrderCargo);
